import {resourceType, cate, resource, deleteResource, mergeSlice, sliceUpload, resourceInfo, resourceAdd} from '@/utils/apis.js'
import Upload from "@/utils/slice_upload";
import DialogUploadResources from './DialogUploadResources';
import EditResourceDialog from "./EditResourceDialog";
export default {
	name: "Index",
	data() {
		return {
			//资源分类列表
			specializedValue: [],
			specializedList: [],
			keyObj: {
				label: 'name',
				value: 'id',
				children: 'children'
			},
			//资源类型
			resourcesTypeList: [],
			typeCurrent: 0,
			//资源库列表
			resourcesTableData: [],
			//分页
			resourcePages: {
				currentPageNum: 1,
				eachPageNum: 10,
				total: 0,
			},
			showDialogMp4: false,
			videoSrc: '',
			dialogFormVisible: false,
			editingRow: null,
			formLabelWidth: '120px',
			uploadDialogStatus: false,
			currentId: 0,
			currentType: [],
		}
	},
	components: {
		DialogUploadResources,
		"editor-dialog":EditResourceDialog,
	},
	created() {
		this.getSpecializedList();
		this.getResourcesType();
		this.getResourcesList();
	},
	methods: {
		//资源分类列表
		getSpecializedList() {
			let param = {
				type: '2'
			}
			cate(param).then((res) => {
				// console.log('资源分类列表',res)
				this.specializedList = res.data;
			}, (err) => {
				console.log(err);
			})
		},
		//选择的分类
		changeResourcesClass() {
			this.getResourcesList();
		},
		//资源类型
		getResourcesType() {
			resourceType().then((res) => {
				this.resourcesTypeList = res.data;
				this.resourceType = [...res.data];
			}, (err) => {
				console.log(err);
			})
		},
		//选择的资源类型
		toggleTypeCur(id) {
			this.typeCurrent = id;
			this.getResourcesList();
		},
		//获取资源库列表
		getResourcesList() {
			let param = {
				page: this.resourcePages.currentPageNum,
				limit: this.resourcePages.eachPageNum,
			}
			if (this.typeCurrent) {
				param.type = this.typeCurrent;
			}
			if (this.specializedValue.length > 0) {
				param.category_id = this.specializedValue[this.specializedValue.length - 1];
			}
			resource(param).then((res) => {
				// console.log('获取资源库列表', res)
				this.resourcesTableData = res.data.list;
				this.resourcePages.total = res.data.total;
			}, (err) => {
				console.log(err);
			})
		},
		uploadResourcesBtn() {
			this.$refs.uploadFilesDialog.dialogUploadResources = true;
		},
		deleteRow(id) {
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteResource(id).then(res => {
					if (res.code === 200) {
						this.$message({
							message: res.msg,
							type: "success",
							onClose: () => {
								this.getResourcesList();
							}
						});
					} else {
						this.$message.warning(res.msg);
					}
				});
			}).catch(() => {
				this.$message.info('已取消删除')
			});
		},
		previewResources(row) {
			if (row.file_ext.toLowerCase() === 'mp4') {
				this.showDialogMp4 = true;
				this.videoSrc = row.preview_path;
			} else {
				window.open(`${localStorage.getItem('hosturl')}pdf/${row.id}`);
			}
		},
		closeDialogMp4() {
			this.showDialogMp4 = false
		},
		downloadResources(row) {
			window.open(row.path);
		},
		editResources(row, index) {
			this.currentId = row.id;
			this.dialogFormVisible = true;
		},
		closeEditDialog(val) {
			this.dialogFormVisible = val;
		},
		//分页
		resourcePagesCurrentChange(val) {
			this.resourcePages.currentPageNum = val;
			this.getResourcesList()
		}
	}
}